import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function FormatCodeUpsert(param: any) {

    const [isOpen, setIsOpen] = useState(param.editDawer);
    const [FormatCode, setFormatCode] = useState<any>(param?.editDataDawer ?? []);

    console.log(param)

    const onFieldChange = (field: any, value: string) => {

    }

    const closeDrawer = () => {
        param.closeDrawer()
    }


    const onReset = () => {

    }


    const onSave = () => {

    }
    return (<>

        <Drawer
            open={isOpen}
            direction='right'
            className='react-drawer allowHscroll '
            size={800}>

            <div className="pull-right ws-5  box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">  Analysis Code   </h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    {/* Body */}
                    <div className="ws-12">
                        {/* Row 1 */}
                        <div className="ws-6 ps">
                            <label className="text-bold">
                                Code<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.code}
                                onChange={(e) => onFieldChange("code", e.target.value)}
                                placeholder="Enter code"
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="text-bold">
                                DIM 1<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.dim1}
                                onChange={(e) => onFieldChange("dim1", e.target.value)}
                                placeholder="Enter DIM 1"
                            />
                        </div>

                        {/* Row 2 */}
                        <div className="ws-6 ps">
                            <label className="text-bold">
                                FormatCode /Source Codes<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.FormatCodeSource}
                                onChange={(e) => onFieldChange("FormatCodeSource", e.target.value)}
                                placeholder="Enter FormatCode/ source codes"
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="text-bold">  DIM 2<span className="ac-required">*</span>  </label>
                            <input
                                className="ac-input"
                                value={FormatCode.dim2}
                                onChange={(e) => onFieldChange("dim2", e.target.value)}
                                placeholder="Enter DIM 2"
                            />
                        </div>

                        {/* Row 3 */}
                        <div className="ws-6 ps">
                            <label className="text-bold">
                                Mechanicals<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.mechanicals}
                                onChange={(e) => onFieldChange("mechanicals", e.target.value)}
                                placeholder="Enter mechanicals"
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="text-bold">
                                DIM 3<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.dim3}
                                onChange={(e) => onFieldChange("dim3", e.target.value)}
                                placeholder="Enter DIM 3"
                            />
                        </div>

                        {/* Row 4 */}
                        <div className="ws-6 ps">
                            <label className="text-bold">Part FormatCode </label>
                            <input
                                className="ac-input"
                                value={FormatCode.partFormatCode || ""}
                                disabled
                                placeholder="No Part FormatCodeAvailable"
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="text-bold">   Cat Format Code<span className="ac-required">*</span>  </label>
                            <input
                                className="ac-input"
                                value={FormatCode.FormatCode}
                                onChange={(e) => onFieldChange("FormatCode", e.target.value)}
                                placeholder="Enter cat Format Code"
                            />
                        </div>

                        {/* Row 5 */}
                        <div className="ws-6 ps">
                            <label className="text-bold">
                                Parent Group<span className="ac-required">*</span>
                            </label>
                            <select
                                className="ac-input"
                                value={FormatCode.parentGroup}
                                onChange={(e) => onFieldChange("parentGroup", e.target.value)}
                            >
                                <option value="">Choose Parent Group</option>
                                {/* replace these with your real parent groups */}
                                <option value="Digital">Digital</option>
                                <option value="Video">Video</option>
                                <option value="Physical">Physical</option>
                            </select>
                        </div>

                        <div className="ws-6 ps">
                            <label className="text-bold">
                                Esc Rate Album<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.escRateAlbum}
                                onChange={(e) => onFieldChange("escRateAlbum", e.target.value)}
                                placeholder="Enter Escalate Rate Album"
                            />
                        </div>

                        {/* Row 6 */}
                        <div className="ws-6 ps">
                            <label className="text-bold">
                                Cat FormatCode <span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.catFormatCode}
                                onChange={(e) => onFieldChange("catFormatCode ", e.target.value)}
                                placeholder="Enter cat FormatCode "
                            />
                        </div>

                        <div className="ws-6 ps">
                            <label className="text-bold">
                                Esc Rate Track<span className="ac-required">*</span>
                            </label>
                            <input
                                className="ac-input"
                                value={FormatCode.escRateTrack}
                                onChange={(e) => onFieldChange("escRateTrack", e.target.value)}
                                placeholder="Enter Escalate Rate Tracks"
                            />
                        </div>

                        <div className="ws-6 ps" />
                        <div className="ws-6 ps">
                            <label className="text-bold">FormatCode Report</label>
                            <input className="ac-input" value={FormatCode.FormatCodeReport} onChange={(e) => onFieldChange("FormatCodeReport", e.target.value)} placeholder="Enter FormatCodereport" />
                        </div>
                    </div>


                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>
                        ✔ Save
                    </button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>
                        ↻ Reset
                    </button>
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>
                        x Close
                    </button>
                </div>
            </div>

        </Drawer>
    </>)
}